import { createContext, useContext } from "react";

interface IsFastConfigurationContextType {
  isFastConfiguration: boolean;
  setIsFastConfiguration: (isFastConfiguration: boolean) => void;
}

export const IsFastConfigurationContext =
  createContext<IsFastConfigurationContextType>({
    isFastConfiguration: false,
    setIsFastConfiguration: (_: boolean) => {},
  });

export function useIsFastConfigurationContext(): IsFastConfigurationContextType {
  return useContext(IsFastConfigurationContext);
}
